import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Settings, HelpCircle, Info } from "lucide-react";
import Input from "../../../../components/FilterBox/Millstage/Input";
import MillstageDropDownFilter from "../../../../components/FilterBox/Millstage/MillstageDropDownFilter";
import { useSelector } from "react-redux";

const MasterForm = ({
  txnDate,
  setTxnDate,
  srNo,
  setSrNo,
  fromStageVal,
  setFromStageVal,
  fromStageId,
  setFromStageId,
  toMachineVal,
  setToMachineVal,
  toMachineId,
  setToMachineId,
  fromSubStageVal,
  setFromSubStageVal,
  fromSubStageId,
  setFromSubStageId,
  processVal,
  setProcessVal,
  processId,
  setProcessId,
  treatmentVal,
  setTreatmentVal,
  treatmentId,
  setTreatmentId,
  processTypeVal,
  setProcessTypeVal,
  processTypeId,
  setProcessTypeId,
  recipeVal,
  setRecipeVal,
  recipeId,
  setRecipeId,
  shadeVal,
  setShadeVal,
  shadeId,
  setShadeId,
  machineVal,
  setMachineVal,
  machineId,
  setMachineId,

  processQualityVal,
  setProcessQualityVal,
  processQualityId,
  setProcessQualityId,

  transactionMasterVal,
  setTransactionMasterVal,
  transactionMasterId,
  setTransactionMasterId,

  remark,
  setRemark,

  costShPercent,
  setCostShPercent,

  // _AvgWeight
  avgWeight,
  setAvgWeight,

  // _BatchNo
  batchNo,
  setBatchNo,

  // _ChartNo
  chartNo,
  setChartNo,

  // _InTime
  inTime,
  setInTime,

  // _Liquor
  liquorVal,
  setLiquorVal,
  liquorId,
  setLiquorId,

  // _MILL
  millVal,
  setMillVal,

  // _Operator
  operatorVal,
  setOperatorVal,
  operatorId,
  setOperatorId,

  // _OutTime
  outTime,
  setOutTime,

  // _PROG
  progVal,
  setProgVal,

  // _PROGDATE
  progDateVal,
  setProgDateVal,

  // _Shift
  shiftVal,
  setShiftVal,

  // _Weight
  weight,
  setWeight,


  errors,
  setErrors,

  setIsHelpModalOpen,
  HelpModel,
  setIsStoppageModalOpen,
  setIsRecipeModalOpen,
  handleProcessFilter,
  isRecipeDetailLoaded,
  handleRecipeChange,
  onTreatmentChange,
  onOpenRecipeDetail,

  setIsLotHelpOpen,
  isLotHelpOpen,

  // Dropdown lists
  stagesList,
  machinesList,
  machinesList1,
  subStagesList,
  processList,
  treatmentList,
  processTypeList,
  recipeList,
  shadeList,
  shiftsList,
  processQualityList,
  TransactionMasterList,
  QualityType,
  QualityType2,
  PartyList,
  ProcessGrpList,


  themeColors,


}) => {
  const {
    bgCard,
    borderTheme,
    btnBg,
    btnText,
    headingCol,
    textTheme,
    accentCol,
    iscolour,
    iscolourDark,
    isdark
  } = themeColors;

  console.log(QualityType);



  const [allFilterFields, setAllFilterFields] = useState([]);
  const [visibleFields, setVisibleFields] = useState([]);


  const [lotHelpData, setLotHelpData] = useState({
    partyId: "",
    partyName: "",

    groupId: "",
    groupName: "",

    qualityId: "",
    qualityName: "",

    lotName: ""
  });

  const {
    AllFilterdata,
    TransFiltersdata
  } = useSelector(
    (state) => state.MillstageEntry || {}
  );

  // =====================================================
  // 1. ALL FILTER API
  // First time ALL fields show karni hain
  // =====================================================

  useEffect(() => {

    const fields =
      AllFilterdata?.ExField ||
      AllFilterdata?.data?.ExField ||
      [];

    console.log("ALL FILTER API FIELDS:", fields);

    if (!Array.isArray(fields)) {
      setAllFilterFields([]);
      setVisibleFields([]);
      return;
    }

    // AllFilter ke complete fields store
    setAllFilterFields(fields);

    // FIRST RENDER:
    // AllFilter ki sari fields show
    setVisibleFields(fields);

  }, [AllFilterdata]);


  // =====================================================
  // 2. TRANSSHOWALL API
  // AllFilter fields ke saath match karke
  // sirf matching fields show karni hain
  // =====================================================
  useEffect(() => {

    if (!allFilterFields.length) {
      return;
    }

    const transFields =
      TransFiltersdata?.ExField ||
      TransFiltersdata?.data?.ExField ||
      [];

    if (!Array.isArray(transFields) || !transFields.length) {
      return;
    }


    const matchedFields = allFilterFields.filter((allField) => {

      const allName =
        allField?.TransParamField
          ?.trim()
          ?.toLowerCase();

      if (!allName) {
        return false;
      }


      return transFields.some((transField) => {

        const transName =
          transField?.TransParamField
            ?.trim()
            ?.toLowerCase();


        return allName === transName;

      });


    });

    setVisibleFields(matchedFields);

  }, [
    TransFiltersdata,
    allFilterFields
  ]);


  // const showShade = showTreatment || showRecipe;

  // =====================================================
  // TransSetup Flags
  // =====================================================

  const transSetup = Array.isArray(TransFiltersdata?.TransSetup)
    ? TransFiltersdata.TransSetup[0]
    : TransFiltersdata?.TransSetup || {};

  const isFlagTrue = (value) =>
    value === true ||
    value === 1 ||
    value === "1" ||
    String(value).toLowerCase() === "true";

  // To Machine
  const showToMachine = !isFlagTrue(
    transSetup?.FlagMultipleToSubStage
  );

  // From Sub-Stage
  const showFromSubStage = !isFlagTrue(
    transSetup?.FlagSubStageInGroup
  );

  // Transaction Master
  const showTransactionMaster = isFlagTrue(
    transSetup?.IsProcessByMaster
  );

  // Machine
  const showMachine = isFlagTrue(
    transSetup?.IsMachineReq
  );

  // Treatment
  const showTreatment = isFlagTrue(
    transSetup?.IsTreatmentReq
  );

  // Recipe
  const showRecipe = isFlagTrue(
    transSetup?.IsReceipeReq
  );

  const isPendingHelpReq = isFlagTrue(
    transSetup?.IsPendingHelpReq
  );

  const IsStopageDetailReq = isFlagTrue(
    transSetup?.IsStopageDetailReq
  );

  const showRecipeDetail = showTreatment || showRecipe;

  // Process Quality
  const isProcessQualityReq = isFlagTrue(
    transSetup?.IsprocessQualityReq
  );

  const isIssueSlipReq = isFlagTrue(
    transSetup?.IsIssueSlipReq
  );

  const IsCostShPerReq = isFlagTrue(
    transSetup?.IsCostShPerReq
  );

  const IsFilterCompulsory = isFlagTrue(
    transSetup?.IsFilterCompulsory
  );

  // Process Quality data available hai ya nahi
  const hasProcessQualityData =
    Array.isArray(TransFiltersdata?.ProcessQuality)


      ? TransFiltersdata.ProcessQuality.length > 0
      : !!TransFiltersdata?.ProcessQuality;

  // Process Quality show condition
  const showProcessQuality =
    isProcessQualityReq ||
    isIssueSlipReq ||
    hasProcessQualityData;

  // Process Quality required condition
  const isProcessQualityRequired = isFlagTrue(
    transSetup?.IsFldProcQualReq
  );

  // Shade / Color show condition
  // Treatment AND Recipe dono true hone chahiye
  const showShade = showTreatment && showRecipe;

  // Shade / Color required condition
  const isShadeRequired = isFlagTrue(
    transSetup?.IsFldShdClrReq
  );

  console.log("TransSetup:", transSetup);

  console.log("TransSetup Flags:", {
    showToMachine,
    showFromSubStage,
    showTransactionMaster,
    showMachine,
    showTreatment,
    showRecipe,

    showProcessQuality,
    isProcessQualityReq,
    isIssueSlipReq,
    hasProcessQualityData,
    isProcessQualityRequired,

    showShade,
    isShadeRequired
  });








  const hasField = (fieldName) => {

    return visibleFields.some(
      (field) =>
        field?.TransParamField?.trim()?.toLowerCase() ===
        fieldName.trim().toLowerCase()
    );
  };

  const getFieldLabel = (fieldName, fallback) => {
    const field = visibleFields.find(
      (item) =>
        item?.TransParamField?.trim()?.toLowerCase() ===
        fieldName.trim().toLowerCase()
    );

    const name = field?.TransParamField;

    if (!name) return fallback;

    return name
      .replace(/^_/, "")
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (char) => char.toUpperCase())
      .trim();
  };

  const handleProcessMasterChange = async (selected) => {

    const id = selected?.value || 0;
    const label = selected?.label || "";

    // =====================================
    // 1. Process Master select
    // =====================================

    setProcessVal(label);
    setProcessId(id);

    // =====================================
    // 2. Process Type reset
    // =====================================

    setProcessTypeVal("");
    setProcessTypeId(null);

    // =====================================
    // 3. Process Master ke ID se
    //    Transaction Master auto select
    // =====================================
    const matchedTransactionMaster = (TransactionMasterList || []).find(
      item =>
        Number(item?.ProcessMstID) === Number(id)
    );

    console.log("Selected ProcessMstID:", id);
    console.log("Matched Transaction Master:", matchedTransactionMaster);

    if (matchedTransactionMaster) {

      setTransactionMasterVal(
        matchedTransactionMaster.label || ""
      );

      setTransactionMasterId(
        matchedTransactionMaster.value || null
      );

    } else {

      setTransactionMasterVal("");
      setTransactionMasterId(null);

    }

    // =====================================
    // 4. Existing API call
    // =====================================

    await handleProcessFilter({
      ProcessMstID: id,
      ProcessTypeID: 0,
    });

  };

  const handleProcessTypeChange = async (selected) => {

    const id = selected?.value || 0;
    const label = selected?.label || "";

    setProcessTypeVal(label);
    setProcessTypeId(id);

    await handleProcessFilter({
      ProcessMstID: processId || 0,
      ProcessTypeID: id,
    });

  };

  const isTreatmentReadOnly =
    isRecipeDetailLoaded &&
    treatmentId !== null &&
    treatmentId !== undefined &&
    treatmentId !== "";

  const isRecipeReadOnly =
    isRecipeDetailLoaded &&
    recipeId !== null &&
    recipeId !== undefined &&
    recipeId !== "";




  return (
    <>

      <Row className="g-4 mb-4">
        {/* Form Cards (70%) */}
        <Col xs={12} lg={8}>
          <div
            style={{
              background: bgCard,
              borderRadius: "14px",
              padding: "20px",
              border: `1px solid ${borderTheme}`,
              boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
              height: "100%"
            }}
          >
            <div className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom border-secondary-subtle">
              <Settings size={18} className="text-secondary" />
              <h6 style={{ margin: 0, fontWeight: "700" }}> Transaction Master Details </h6>
            </div>

            <Row className="g-3">
              {/* Row 1 */}
              <Col xs={12} md={6}>
                <Input
                  label="Transaction Date"
                  type="datetime-local"
                  value={txnDate}
                  onChange={(e) => setTxnDate(e.target.value)}

                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>
              <Col xs={12} md={6}>
                <div className={errors.srNo ? "border border-danger rounded-3 p-1" : ""}>

                  <Input
                    label="SrNo (Voucher Serial No) *"
                    placeholder="Enter Voucher Serial No"
                    value={srNo}
                    onChange={(e) => {
                      setSrNo(e.target.value);
                      if (e.target.value.trim()) {
                        setErrors(prev => {
                          const newErrors = { ...prev };
                          delete newErrors.srNo;
                          return newErrors;
                        });
                      }
                    }}

                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                  />
                </div>
                {errors.srNo && <small className="text-danger ps-2">{errors.srNo}</small>}
              </Col>

              {/* Row 2 */}
              <Col xs={12} md={6}>
                <MillstageDropDownFilter
                  label="From Stage"
                  data={stagesList}
                  selectedValue={fromStageVal}
                  setSelectedValue={setFromStageVal}
                  selectedId={fromStageId}
                  setSelectedId={setFromStageId}
                  isMulti={false}
                  placeholder="Select From Stage"

                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              {showToMachine && (
                <Col xs={12} md={6}>
                  <MillstageDropDownFilter
                    label={
                      <span>
                        To Machine
                        <span style={{ color: "#dc3545", fontWeight: "700", marginLeft: "4px" }}>*</span>
                      </span>
                    }
                    data={machinesList}
                    selectedValue={toMachineVal}
                    setSelectedValue={setToMachineVal}
                    selectedId={toMachineId}
                    setSelectedId={setToMachineId}
                    isMulti={false}
                    placeholder="Select To Machine"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                  />
                </Col>
              )}

              {/* Row 3 */}
              {showFromSubStage && (
                <Col xs={12} md={6}>
                  <MillstageDropDownFilter
                    label="From Sub-Stage"
                    data={subStagesList}
                    selectedValue={fromSubStageVal}
                    setSelectedValue={setFromSubStageVal}
                    selectedId={fromSubStageId}
                    setSelectedId={setFromSubStageId}
                    isMulti={false}
                    placeholder="Select From Sub-Stage"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                  />
                </Col>
              )}

              {isPendingHelpReq && (
                <Col xs={12} md={6}>
                  <div className="d-flex flex-column h-100 justify-content-end" style={{ paddingBottom: "2px" }}>
                    <button
                      type="button"
                      onClick={() => {
                        if (IsFilterCompulsory === true) {
                          setIsLotHelpOpen(true);
                        } else {
                          HelpModel();
                        }
                      }}
                      style={{
                        background: btnBg,
                        color: btnText,
                        border: "none",
                        borderRadius: "10px",
                        padding: "10px 16px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        width: "100%",
                        height: "44px"
                      }}
                      className="hover-scale-btn"
                    >
                      <HelpCircle size={16} /> Lot Help
                    </button>
                  </div>
                </Col>
              )}

              {/* Row 4 */}
              <Col xs={12} md={6}>
                <MillstageDropDownFilter
                  label={
                    <span>
                      Process Master
                      <span style={{ color: "#dc3545", fontWeight: "700", marginLeft: "4px" }}>*</span>
                    </span>
                  }
                  data={processList}
                  selectedValue={processVal}
                  setSelectedValue={setProcessVal}
                  selectedId={processId}
                  setSelectedId={setProcessId}
                  isMulti={false}
                  placeholder="Select Process Master"
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  onChange={handleProcessMasterChange}

                />
              </Col>

              {showTransactionMaster && (
                <Col xs={12} md={6}>
                  <MillstageDropDownFilter
                    label="Transaction Master"
                    data={TransactionMasterList}
                    selectedValue={transactionMasterVal}
                    setSelectedValue={setTransactionMasterVal}
                    selectedId={transactionMasterId}
                    setSelectedId={setTransactionMasterId}
                    isMulti={false}
                    placeholder="Select Transaction Master"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                  />
                </Col>
              )}

              {showTreatment && (
                <Col xs={12} md={6}>
                  <div
                    style={{
                      pointerEvents: isTreatmentReadOnly  ? "none" : "auto",
                      opacity: isTreatmentReadOnly  ? 0.7 : 1,
                    }}
                  >
                    <MillstageDropDownFilter
                      label="Treatment"
                      data={treatmentList}
                      selectedValue={treatmentVal}
                      setSelectedValue={setTreatmentVal}
                      selectedId={treatmentId}
                      setSelectedId={setTreatmentId}
                      isMulti={false}
                      placeholder="Select Treatment"
                      isdark={isdark}
                      iscolour={iscolour}
                      iscolourDark={iscolourDark}
                      onChange={onTreatmentChange}
                    />
                  </div>
                </Col>
              )}

              {/* Row 5 */}
              <Col xs={12} md={6}>
                <MillstageDropDownFilter
                  label={
                    <span>
                      Process Type
                      <span style={{ color: "#dc3545", fontWeight: "700", marginLeft: "4px" }}>*</span>
                    </span>
                  }
                  data={processTypeList}
                  selectedValue={processTypeVal}
                  setSelectedValue={setProcessTypeVal}
                  selectedId={processTypeId}
                  setSelectedId={setProcessTypeId}
                  isMulti={false}
                  placeholder="Select Process Type"
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  onChange={handleProcessTypeChange}
                />
              </Col>

              {showRecipe && (
                <Col xs={12} md={6}>
                  <div
                    style={{
                      pointerEvents: isRecipeReadOnly  ? "none" : "auto",
                      opacity: isRecipeReadOnly  ? 0.7 : 1,
                    }}
                  >
                    <MillstageDropDownFilter
                      label="Recipe"
                      data={recipeList}
                      selectedValue={recipeVal}
                      setSelectedValue={setRecipeVal}
                      selectedId={recipeId}
                      setSelectedId={setRecipeId}
                      isMulti={false}
                      placeholder="Select Recipe"
                      isdark={isdark}
                      iscolour={iscolour}
                      iscolourDark={iscolourDark}
                      onChange={handleRecipeChange}
                    />
                  </div>
                </Col>
              )}

              {/* Row 6 */}

              {showShade && (
                <Col xs={12} md={6}>
                  <MillstageDropDownFilter
                    label={
                      <span>
                        Shade / Color
                        {isProcessQualityRequired && (
                          <span
                            style={{
                              color: "#dc3545",
                              fontWeight: "700",
                              marginLeft: "4px",
                            }}
                          >
                            *
                          </span>
                        )}
                      </span>
                    }
                    data={shadeList}
                    selectedValue={shadeVal}
                    setSelectedValue={setShadeVal}
                    selectedId={shadeId}
                    setSelectedId={setShadeId}
                    isMulti={false}
                    placeholder="Select Shade / Color"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                  />
                </Col>
              )}
              {showMachine && (
                <Col xs={12} md={6}>
                  <MillstageDropDownFilter
                    label={
                      <span>
                        Machine
                        <span
                          style={{
                            color: "#dc3545",
                            fontWeight: "700",
                            marginLeft: "4px",
                          }}
                        >
                          *
                        </span>
                      </span>
                    }
                    data={machinesList1}
                    selectedValue={machineVal}
                    setSelectedValue={setMachineVal}
                    selectedId={machineId}
                    setSelectedId={setMachineId}
                    isMulti={false}
                    placeholder="Select Machine"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                  />
                </Col>
              )}

              {showProcessQuality && (
                <Col xs={12} md={6}>
                  <MillstageDropDownFilter
                    label={
                      <span>
                        Process Quality
                        {isProcessQualityRequired && (
                          <span
                            style={{
                              color: "#dc3545",
                              fontWeight: "700",
                              marginLeft: "4px",
                            }}
                          >
                            *
                          </span>
                        )}
                      </span>
                    }
                    data={processQualityList}
                    selectedValue={processQualityVal}
                    setSelectedValue={setProcessQualityVal}
                    selectedId={processQualityId}
                    setSelectedId={setProcessQualityId}
                    isMulti={false}
                    placeholder="Select Process Quality"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                    required={isProcessQualityRequired}
                  />
                </Col>
              )}

              <Col xs={12} md={6}>
                <div className="d-flex gap-2 h-100 align-items-end" style={{ paddingBottom: "2px" }}>

                  {IsStopageDetailReq && (
                    <button
                      type="button"
                      onClick={() => setIsStoppageModalOpen(true)}
                      style={{
                        background: "rgba(100, 116, 139, 0.15)",
                        color: textTheme,
                        border: "none",
                        borderRadius: "10px",
                        padding: "10px",
                        fontWeight: "600",
                        flex: 1,
                        fontSize: "12px",
                        height: "44px"
                      }}
                      className="hover-scale-btn"
                    >
                      Stopage Detail
                    </button>
                  )}

                  {/* Recipe Detail - Treatment OR Recipe */}
                  {showRecipeDetail && (
                    <button
                      type="button"
                      onClick={() => onOpenRecipeDetail(false)}
                      style={{
                        background: "rgba(100, 116, 139, 0.15)",
                        color: textTheme,
                        border: "none",
                        borderRadius: "10px",
                        padding: "10px",
                        fontWeight: "600",
                        flex: 1,
                        fontSize: "12px",
                        height: "44px"
                      }}
                      className="hover-scale-btn"
                    >
                      Receipe Detail
                    </button>
                  )}

                </div>
              </Col>


              {showRecipeDetail && (
                <Col >
                  <Input
                    label={
                      <span>
                        Cost Sh. (%)
                        {isProcessQualityRequired && (
                          <span
                            style={{
                              color: "#dc3545",
                              fontWeight: "700",
                              marginLeft: "4px",
                            }}
                          >
                            *
                          </span>
                        )}
                      </span>
                    }
                    value={costShPercent}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (
                        value === "" ||
                        (!isNaN(value) &&
                          Number(value) >= 0 &&
                          Number(value) <= 100)
                      ) {
                        setCostShPercent(value);
                      }
                    }}
                    placeholder="Enter Cost Sh. (%)"
                    type="number"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                  />
                </Col>
              )}



              {/* Row 8 */}
              <Col xs={12}>
                <div className="d-flex flex-column">
                  <label
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      marginBottom: "5px",
                      color: headingCol
                    }}
                  >
                    Lot Remark / Special Instructions
                  </label>
                  <textarea
                    placeholder="Provide details about process recipe adjustments or roll tension issues"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    rows={2}
                    style={{
                      width: "100%",
                      padding: "12px 20px",
                      border: `1px solid ${borderTheme}`,
                      borderRadius: "12px",
                      outline: "none",
                      fontSize: "14px",
                      color: textTheme,
                      background: isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour9 || "#2d1f0f",
                      resize: "none"
                    }}
                  />
                </div>
              </Col>
            </Row>

          </div>


        </Col>


        {/* Parameters Sidebar (30%) */}
        <Col xs={12} lg={4}>
          <div
            style={{
              background: bgCard,
              borderRadius: "14px",
              padding: "20px",
              border: `1px solid ${borderTheme}`,
              boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
              height: "100%"
            }}
          >
            <div className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom border-secondary-subtle">
              <Info size={18} className="text-secondary" />

              <h6
                style={{
                  margin: 0,
                  fontWeight: "700"
                }}
              >
                Operational Parameters
              </h6>
            </div>

            {/* ==========================================
    Operational Parameters
========================================== */}

            <div className="d-flex flex-column gap-3">

              {hasField("_Shift") && (
                <Input
                  label={getFieldLabel("_Shift", "Shift")}
                  type="text"
                  placeholder={`Enter ${getFieldLabel("_Shift", "Shift")}`}
                  value={shiftVal}
                  onChange={(e) => setShiftVal(e.target.value)}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              )}

              {hasField("_InTime") && (
                <Input
                  label={getFieldLabel("_InTime", "In Time")}
                  type="datetime-local"
                  value={inTime}
                  onChange={(e) => setInTime(e.target.value)}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              )}

              {hasField("_OutTime") && (
                <Input
                  label={getFieldLabel("_OutTime", "Out Time")}
                  type="datetime-local"
                  value={outTime}
                  onChange={(e) => setOutTime(e.target.value)}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              )}

              {hasField("_AvgWeight") && (
                <Input
                  label={getFieldLabel("_AvgWeight", "Avg Weight")}
                  type="text"
                  placeholder={`Enter ${getFieldLabel("_AvgWeight", "Avg Weight")}`}
                  value={avgWeight}
                  onChange={(e) => setAvgWeight(e.target.value)}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              )}

              {hasField("_Weight") && (
                <Input
                  label={getFieldLabel("_Weight", "Weight")}
                  type="text"
                  placeholder={`Enter ${getFieldLabel("_Weight", "Weight")}`}
                  value={

                    weight
                  }
                  onChange={(e) => setWeight(e.target.value)}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              )}

              {hasField("_BatchNo") && (
                <Input
                  label={getFieldLabel("_BatchNo", "Batch No")}
                  type="text"
                  placeholder={`Enter ${getFieldLabel("_BatchNo", "Batch No")}`}
                  value={batchNo}
                  onChange={(e) => setBatchNo(e.target.value)}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              )}

              {hasField("_ChartNo") && (
                <Input
                  label={getFieldLabel("_ChartNo", "Chart No")}
                  type="text"
                  placeholder={`Enter ${getFieldLabel("_ChartNo", "Chart No")}`}
                  value={chartNo}
                  onChange={(e) => setChartNo(e.target.value)}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              )}

              {hasField("_Liquor") && (
                <Input
                  label={getFieldLabel("_Liquor", "Liquor")}
                  type="text"
                  placeholder={`Enter ${getFieldLabel("_Liquor", "Liquor")}`}
                  value={liquorVal}
                  onChange={(e) => setLiquorVal(e.target.value)}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              )}

              {hasField("_MILL") && (
                <Input
                  label={getFieldLabel("_MILL", "Mill")}
                  type="text"
                  placeholder={`Enter ${getFieldLabel("_MILL", "Mill")}`}
                  value={millVal}
                  onChange={(e) => setMillVal(e.target.value)}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              )}

              {hasField("_Operator") && (
                <Input
                  label={getFieldLabel("_Operator", "Operator")}
                  type="text"
                  placeholder={`Enter ${getFieldLabel("_Operator", "Operator")}`}
                  value={operatorVal}
                  onChange={(e) => setOperatorVal(e.target.value)}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              )}


              {hasField("_PROG") && (
                <Input
                  label={getFieldLabel("_PROG", "Program")}
                  type="text"
                  placeholder={`Enter ${getFieldLabel("_PROG", "Program")}`}
                  value={progVal}
                  onChange={(e) => setProgVal(e.target.value)}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              )}

              {hasField("_PROGDATE") && (
                <Input
                  label={getFieldLabel("_PROGDATE", "Prog Date")}
                  type="datetime-local"
                  placeholder={`Enter ${getFieldLabel("_PROGDATE", "Prog Date")}`}
                  value={progDateVal}
                  onChange={(e) => setProgDateVal(e.target.value)}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              )}






              {/* ==========================================
      12. _Weight
  ========================================== */}


            </div>
          </div>
        </Col>

        {IsFilterCompulsory && isLotHelpOpen && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.45)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10000
            }}
          >
            <div
              style={{
                width: "90%",
                maxWidth: "650px",
                background: bgCard,
                border: `1px solid ${borderTheme}`,
                borderRadius: "16px",
                boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
                overflow: "visible"
              }}
            >

              {/* HEADER */}
              <div
                style={{
                  padding: "16px 20px",
                  borderBottom: `1px solid ${borderTheme}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between"
                }}
              >
                <h5
                  style={{
                    margin: 0,
                    color: headingCol,
                    fontWeight: "700"
                  }}
                >
                  Lot Help
                </h5>

                <button
                  type="button"
                  onClick={() => setIsLotHelpOpen(false)}
                  style={{
                    border: "none",
                    background: "transparent",
                    fontSize: "22px",
                    color: textTheme,
                    cursor: "pointer"
                  }}
                >
                  ×
                </button>
              </div>

              {/* BODY */}
              <div style={{ padding: "20px" }}>

                <Row className="g-3">

                  {/* PARTY */}
                  <Col xs={12} md={6}>
                    <MillstageDropDownFilter
                      label="Party"
                      data={PartyList || []}
                      selectedValue={lotHelpData.partyName}
                      setSelectedValue={(value) =>
                        setLotHelpData((prev) => ({
                          ...prev,
                          partyName: value
                        }))
                      }
                      selectedId={lotHelpData.partyId}
                      setSelectedId={(value) =>
                        setLotHelpData((prev) => ({
                          ...prev,
                          partyId: value
                        }))
                      }
                      isMulti={false}
                      placeholder="Select Party"
                      isdark={isdark}
                      iscolour={iscolour}
                      iscolourDark={iscolourDark}
                    />
                  </Col>

                  <Col xs={12} md={6}>
                    <MillstageDropDownFilter
                      label="Group"
                      data={processList || []}
                      selectedValue={lotHelpData.groupName}
                      setSelectedValue={(value) =>
                        setLotHelpData((prev) => ({
                          ...prev,
                          groupName: value
                        }))
                      }
                      selectedId={lotHelpData.groupId}
                      setSelectedId={(value) =>
                        setLotHelpData((prev) => ({
                          ...prev,
                          groupId: value
                        }))
                      }
                      isMulti={false}
                      placeholder="Select Group"
                      isdark={isdark}
                      iscolour={iscolour}
                      iscolourDark={iscolourDark}
                    />
                  </Col>

                  <Col xs={12} md={6}>
                    <MillstageDropDownFilter
                      label="Quality"
                      data={QualityType2 || []}
                      selectedValue={lotHelpData.qualityName}
                      setSelectedValue={(value) =>
                        setLotHelpData((prev) => ({
                          ...prev,
                          qualityName: value
                        }))
                      }
                      selectedId={lotHelpData.qualityId}
                      setSelectedId={(value) =>
                        setLotHelpData((prev) => ({
                          ...prev,
                          qualityId: value
                        }))
                      }
                      isMulti={false}
                      placeholder="Select Quality"
                      isdark={isdark}
                      iscolour={iscolour}
                      iscolourDark={iscolourDark}
                    />
                  </Col>

                  {/* LOT NAME */}
                  <Col xs={12} md={6}>
                    <Input
                      label="Lot Name"
                      value={lotHelpData.lotName}
                      onChange={(e) =>
                        setLotHelpData((prev) => ({
                          ...prev,
                          lotName: e.target.value
                        }))
                      }
                      placeholder="Enter Lot Name"

                      isdark={isdark}
                      iscolour={iscolour}
                      iscolourDark={iscolourDark}
                    />
                  </Col>

                </Row>
              </div>

              {/* FOOTER */}
              <div
                style={{
                  padding: "14px 20px",
                  borderTop: `1px solid ${borderTheme}`,
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px"
                }}
              >
                <button
                  type="button"
                  onClick={() => setIsLotHelpOpen(false)}
                  style={{
                    border: `1px solid ${borderTheme}`,
                    background: "transparent",
                    color: textTheme,
                    borderRadius: "10px",
                    padding: "9px 18px",
                    fontWeight: "600"
                  }}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  onClick={() => {
                    if (IsFilterCompulsory === true) {
                      // Filter compulsory hai
                      HelpModel(lotHelpData);
                    } else {
                      // Filter compulsory nahi hai
                      HelpModel();
                    }

                    setIsLotHelpOpen(false);
                  }}
                  style={{
                    border: "none",
                    background: btnBg,
                    color: btnText,
                    borderRadius: "10px",
                    padding: "9px 18px",
                    fontWeight: "600"
                  }}
                >
                  Filter
                </button>
              </div>

            </div>
          </div>
        )}

      </Row>
    </>
  );
};

export default MasterForm;
